import { Card } from "antd";
import "../../styles/doctorCard.scss";
import "./feedback.scss";
import { $host } from "../../http/index";

const ReviewerCard = ({ reviewer }) => {
  const language = localStorage.getItem("lang")?localStorage.getItem("lang"):'am'
  const firstNameKey = `firstName${language.toUpperCase()}`;
  const lastNameKey = `lastName${language.toUpperCase()}`;


  const position = `text${language.toUpperCase()}`;
  
  return (
    <Card className="doctor-card bg-color" hoverable style={{background:"white"}}>
      <img
        src={
          $host.defaults.baseURL +
          'photos/feedback/' +
          (reviewer.img_main ? reviewer.img_main : 'docdefault.jpg')
        }
        alt={`${reviewer[firstNameKey]} ${reviewer[`firstName${localStorage.getItem('language')}`]}`} className="doctor-image" />
      <div className="doctor-info">
        <h3 className="text-bleck">{reviewer[firstNameKey]} {reviewer[lastNameKey]}</h3>
        <p>{reviewer[position]}</p>
      </div>
    </Card>
  );
};

export default ReviewerCard;
